import { rem } from 'polished';
import styled, { css } from '../../../styles/theme';
import { ButtonStyled } from '../ButtonStyled';

export const ButtonStyledDS = styled(ButtonStyled)`
    width: ${rem(240)};
    height: ${rem(42)};

    ${({ primary }) =>
        primary &&
        css`
            color: ${({ theme }) => theme.colors.white};
            background: ${({ theme }) => theme.colors.black};
            border-radius: ${rem(24)};
            font-size: ${({ theme }) => theme.fontSizes.h5};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            height: ${rem(48)};
            text-transform: unset;
            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.primary};
            }
        `}

    ${({ secondary }) =>
        secondary &&
        css`
            color: ${({ theme }) => theme.colors.black1};
            background: ${({ theme }) => theme.colors.white};
            border: 1px solid ${({ theme }) => theme.colors.black1};
            border-radius: ${rem(24)};
            font-size: ${({ theme }) => theme.fontSizes.h5};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            height: ${rem(48)};
            text-transform: unset;
            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.grey4};
                color: ${({ theme }) => theme.colors.primary};
                border-color: ${({ theme }) => theme.colors.primary};
            }
        `}

    ${({ secondary, disabled }) =>
        secondary &&
        disabled &&
        css`
            background: ${({ theme }) => theme.colors.secondaryDisabled};
            color: ${({ theme }) => theme.colors.default};
            border: 1px solid ${({ theme }) => theme.colors.default};
            opacity: 0.25;
        `}

    ${({ outline }) =>
        outline &&
        css`
            background: ${({ theme }) => theme.colors.primary};
            border: 1px solid currentColor;
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            color: ${({ theme }) => theme.colors.white};
            font-size: ${({ theme }) => theme.fontSizes.textSubMedium};
            padding: ${rem(10)} ${rem(25)};

            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.primaryHover};
                color: ${({ theme }) => theme.colors.white};
            }
        `}
`;
